import { render, staticRenderFns } from "./PicPreviewComp.vue?vue&type=template&id=490cf4da&"
import script from "./PicPreviewComp.vue?vue&type=script&lang=js&"
export * from "./PicPreviewComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports